export const NavBarRoutes = [
  { name: "Strona główna", route: "/" },
  { name: "O nas", route: "/about" },
  { name: "Usługi", route: "/uslugi" },
  { name: "Aktualności", route: "/aktualnosci" },
  { name: "Partnerzy", route: "/partnerzy" },
  { name: "Kontakt", route: "/kontakt" },
];
